import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { ResourceGovernanceSettingDefiniton } from '~src/contentDefinitions/ResourceGovernanceSettingDefinition';
import { SettingsSectionList } from '~src/settings/components/settings-coordinator/SettingsSectionList';
import { SpaceContentsRequestAction } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { ExplorerTestIds } from '~src/spacesPlatform/components/Explorer/Explorer';
import { ExplorerEmptyStateProps } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerEmpyState';
import { ServerSettingsSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';
import { cssClass } from '~src/style';

import { openResourceGovernanceEditDefaultLimitsDialog } from './ResourceGovernanceEditDefaultLimitsDialog';
import { SchedulesGovernanceLimitsSection } from './SchedulesGovernanceLimitsSection';


export const ResourceGovernanceSubspaceName: ServerSettingsSubspaceName = 'resourcesgovernance';

// Used by unit tests
export const SiteJobLimitsSectionName = 'siteJobsLimits';
export const DefaultSiteLimitsSectionName = 'defaultSiteLimits';
export const TableSectionName = 'table';
export const SiteJobsLimitsLinkTestId = 'site-jobs-limits-learn-more';
export const SiteJobsLimitsLinkToken = 'site-resource-limits-intro';
export interface ResourceGovernanceSubspaceDispatchProps {
  readonly requestSpaceContents: () => SpaceContentsRequestAction;
}

export interface ResourceGovernanceOwnProps {}

export interface ResourceGovernanceStateProps {
  isFirstRun: boolean;
}

export type ResourceGovernanceProps = ResourceGovernanceSubspaceDispatchProps & ResourceGovernanceOwnProps & ResourceGovernanceStateProps;

export function ResourceGovernanceSubspace(props: ResourceGovernanceProps) {
  const siteJobsLimitsSection = <>
    <div className="tb-settings-group-name" data-tb-test-id={SiteJobLimitsSectionName + '-header'}>
      {Messages.resourceGovernanceSiteJobsLimitsHeader()}
    </div>
    <div className="tb-indent" data-tb-test-id={SiteJobLimitsSectionName + '-body'}>
      {Messages.resourceGovernanceSiteJobsLimitsBody()}
      <TextLinkWidget testId={SiteJobsLimitsLinkTestId}
                      href={HelpService.getServerHelpUrlByCategory(SiteJobsLimitsLinkToken)}
                      target={'_blank'}>
        {Messages.resourceGovernanceLearnMoreMessage()}
      </TextLinkWidget>
    </div>
  </>;
  const defaultSiteLimitsSection = <>
    <div className="tb-settings-group-name" style={{ marginTop: 12 }} data-tb-test-id={DefaultSiteLimitsSectionName + '-header'}>
      {Messages.resourceGovernanceDefaultSiteLimitsHeader()}
    </div>
    <div className="tb-indent" data-tb-test-id={DefaultSiteLimitsSectionName + '-body'}>
      {Messages.resourceGovernanceDefaultSiteLimitsBody()}
    </div>
    <SchedulesGovernanceLimitsSection isFirstRun={props.isFirstRun} />
  </>;
  const cssPrefix = 'ResourceGovernance';
  const tableStyle = cssClass(cssPrefix, 'space-subplace-area', {
    flex: 1,
    position: 'relative',
    minHeight: 250,
  });
  const tableSection = <div className={tableStyle}>
    <ConnectedExplorer
      supportedDisplayModes={ResourceGovernanceSettingDefiniton.supportedDisplayModes}
      emptyStateProps={{
        dataTestId: ExplorerTestIds.ExplorerNoContent,
        iconUrl: '',
        primaryMessage: Messages.resourceGovernanceEmptyStateMessages(),
        secondaryMessage: '',
        actionButtonMessage: Messages.resourceGovernanceSetDefaultTitle(),
        onActionButton: () => openResourceGovernanceEditDefaultLimitsDialog({isFirstRun: true}),
      }}
      toolbarProps={{
        supportFilterPanel: false,
        toolbarVisibility: 'enabled',
        hideSelection: false,
      }}
    />
  </div>;
  const sections = [
    {
      name: SiteJobLimitsSectionName,
      component: () => siteJobsLimitsSection,
    },
    {
      name: DefaultSiteLimitsSectionName,
      component: () => defaultSiteLimitsSection,
    },
  ];

  // Our subspace is already in a flex container (hence the flex: 1)
  // but we also need to create a flex containter of our own own (hence the other flex attributes)
  const settingsFormStyle = style({
    flex: 1,
    display: 'flex',
    paddingTop: 30,
    overflow: 'auto',
    flexDirection: 'column',
  });
  const settingsSectionListFullWidthStyle = style({
    marginLeft: 24,
    marginRight: 24,
  });
  const settings = {

  };
  return (<>
    <div className={settingsFormStyle}>
      <SettingsSectionList
        sections={sections}
        settings={settings}
        formStyle={settingsSectionListFullWidthStyle}
      />
      {tableSection}
    </div>
  </>);
}


function emptyStateProps(): ExplorerEmptyStateProps {
  return {
    dataTestId: ExplorerTestIds.ExplorerNoContent,
    iconUrl: '',
    primaryMessage: Messages.contentEmptyMessage(),
    secondaryMessage: '',
  };
}
